import { Component } from '@theme/component';
import { addItemToCart } from '@theme/cart-add-utility';

/**
 * @typedef {object} Refs
 * @property {HTMLElement[]} giftProductItems - Gift product item containers.
 *
 * @extends {Component<Refs>}
 */
class CartGiftProducts extends Component {
  /**
   * Adds a gift product to the cart with quantity 1.
   * @param {string} variantId - The variant ID to add.
   */
  async addGiftProduct(variantId) {
    // The loading class blocks only the mouse; a held Enter key would add the product again
    if (this.classList.contains('cart-gift-products--loading')) return;
    this.classList.add('cart-gift-products--loading');

    try {
      await addItemToCart(this, variantId, 'cart-gift-products');
    } catch (error) {
      console.error('Error adding gift product:', error);
    } finally {
      this.classList.remove('cart-gift-products--loading');
    }
  }
}

if (!customElements.get('cart-gift-products')) {
  customElements.define('cart-gift-products', CartGiftProducts);
}
